
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35390',
  depVersions: {
  "documents-public-ui": "static-1.35390",
  "atom": "static-1.5471",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2874",
  "client-types": "static-1.504",
  "cssUtils": "static-1.1012",
  "customer-data-filters-ui": "static-1.41148",
  "customer-data-objects": "static-1.8083",
  "customer-data-property-utils": "static-1.8458",
  "documents-lib": "static-1.35395",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.377",
  "FormsCommonComponents": "static-1.86708",
  "FormUrlGenerator": "static-2.5104",
  "foundations-theming-specialty": "static-1.2586",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5981",
  "hs-test-utils": "static-1.8428",
  "hub-http": "static-1.6602",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12190",
  "HubStyleTokens": "static-2.11883",
  "I18n": "static-7.1690",
  "icons": "static-2.698",
  "jasmine-immutable": "static-1.3371",
  "jasmine-runner": "static-1.6839",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7542",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3280",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5773",
  "quartz": "static-1.7560",
  "react": "static-7.202",
  "react-dlb": "static-1.92",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17120",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5611",
  "react-virtualized": "static-2.110",
  "reference-resolvers": "static-1.8573",
  "reference-resolvers-lite": "static-1.8494",
  "reporting-data": "static-1.69085",
  "reporting-reports": "static-1.68761",
  "reporting-snowflake": "static-1.57701",
  "reporting-testing-lib": "static-1.11018",
  "reporting-visualizations": "static-1.61159",
  "reselect": "static-3.15",
  "sales-content-partitioning": "static-1.9335",
  "sanitize": "static-1.4863",
  "sanitize-text": "static-1.8549",
  "SharedI18nStrings": "static-1.186",
  "SharedLegalStrings": "static-1.2121",
  "signup-constants": "static-1.19768",
  "signup-ui-url-generator": "static-2.8449",
  "StyleGuideUI": "static-3.511",
  "superstore": "static-1.5151",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5138",
  "ui-addon-form-validation": "static-1.11334",
  "ui-asset-management-lib": "static-1.11493",
  "ui-images": "static-2.1268",
  "UIComponents": "static-3.8829",
  "usage-tracker": "static-1.7703",
  "usage-tracker-container": "static-1.7693",
  "usage-tracker-core": "static-1.7553",
  "viral-links-lib": "static-1.7466",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10038",
  "foundations-components": "static-1.8622",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1338",
  "quartz-core": "static-1.6779",
  "quick-fetch": "static-1.4180",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "rpc-client-utils": "static-1.5058",
  "ui-addon-i18n": "static-1.11540",
  "ui-addon-upgrades": "static-9.18485",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3837",
  "quartz-webpack": "static-1.3784",
  "foundations-assets": "static-1.5280",
  "foundations-theming": "static-1.4870",
  "hub-http-janus": "static-1.895",
  "hub-http-shared-msw-handlers": "static-1.10757",
  "hubspotter-http": "static-1.4915",
  "sassPrefix": "static-1.280",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43929",
  "customer-data-filters-ui-msw-helpers": "static-1.23583",
  "customer-data-objects-ui-components": "static-1.13421",
  "customer-data-reference-ui-components": "static-1.13560",
  "customer-data-ui-utilities": "static-1.10223",
  "events-data-lib": "static-1.639",
  "framework-builder-read-service-client": "static-1.4277",
  "hs-resources": "static-1.584",
  "immer": "static-1.104",
  "inbound-db-meta-service-client": "static-1.3729",
  "inbound-db-properties-service-client": "static-1.4099",
  "multi-account-reference-resolvers": "static-1.1395",
  "onboarding-scopes": "static-1.6844",
  "onboarding-tours": "static-1.17262",
  "pulse": "static-1.1027",
  "reporting-datasets-permissions-lib": "static-1.14614",
  "segments-client-types": "static-1.11861",
  "stylex": "static-1.45",
  "trellis-assets": "static-1.2877",
  "trellis-components": "static-1.2896",
  "trellis-theming": "static-1.1368",
  "ui-addon-teams": "static-1.21968",
  "quartz-auth": "static-1.1235",
  "ui-business-units-lib": "static-1.9485",
  "usage-tracker-session-replay": "static-1.5389",
  "ai-components-ui-library": "static-1.9879",
  "ContentUtils": "static-1.69297",
  "customer-data-properties": "static-1.52822",
  "forms-ai-lib": "static-1.4870",
  "forms-utils-lib": "static-1.13208",
  "foundations-components-test-utils": "static-1.6105",
  "react-dnd-compat": "static-1.5005",
  "react-tinymce": "static-1.56128",
  "tinymce-config": "static-2.55254",
  "ui-gdpr-components": "static-1.10648",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3855",
  "HeadJS": "static-2.810",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3539",
  "msw": "static-1.39",
  "msw-config": "static-1.15",
  "testing-library": "static-1.162",
  "hs-locale-management": "static-1.350",
  "ui-fonts": "static-1.1145",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4701",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1225",
  "web-vitals": "static-1.18",
  "batch-promise": "static-1.1937",
  "external-options-client-types": "static-1.4397",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7286",
  "quartz-i18n": "static-1.1235",
  "frontend-preferences-client": "static-1.8312",
  "graphql": "static-1.92",
  "persist-promise": "static-1.4094",
  "reporting-client-types": "static-1.2764",
  "apollo-stack-hubspot": "static-3.97",
  "growth-payments-core": "static-1.26343",
  "hubspot-apollo-client": "static-1.5266",
  "foundations-components-legacy": "static-1.1647",
  "quartz-routing": "static-1.990",
  "hs-story-utils": "static-1.9816",
  "react-flip-move": "static-1.81",
  "nested-table": "static-1.627",
  "seat-types-lib": "static-1.888",
  "timezone-utils": "static-2.5622",
  "react-create-root-preference": "static-1.87",
  "bend-plugin-foundations-components": "static-1.4891",
  "floating-ui": "static-1.66",
  "react-aria": "static-1.75",
  "tanstack-table": "static-1.64",
  "opentelemetry-fe-types": "static-1.176",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.591",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.551",
  "quartz-test": "static-1.1235",
  "quartz-tracking": "static-1.939",
  "bend-plugin-chirp-manifest": "static-1.468",
  "chirp-fetch": "static-1.2292",
  "merchandise-lib": "static-1.282",
  "purchase-motions-components": "static-1.6532",
  "ts-schema": "static-1.4350",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3353",
  "restore-request-side-panel-lib": "static-1.1855",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5014",
  "conditional-properties-service-client": "static-1.4072",
  "crm-pipelines-api-client-types": "static-1.4402",
  "event-emitter": "static-1.1350",
  "fdsr-migration-layer": "static-1.405",
  "multi-currency-client-types": "static-1.3966",
  "getting-started-shared-tasks": "static-1.19404",
  "growth-data-modal": "static-1.6010",
  "growth-onboarding-confetti": "static-1.3455",
  "growth-onboarding-next-action-utils": "static-1.2839",
  "navigation-components": "static-1.18991",
  "onboarding-tours-client": "static-1.5477",
  "onboarding-tours-utils": "static-1.1329",
  "ui-shepherd-react": "static-3.10663",
  "ui-shepherd-tracker": "static-1.8044",
  "ui-universal-auth": "static-1.9574",
  "user-context": "static-1.5473",
  "bend-plugin-pulse": "static-1.530",
  "fast-json-patch": "static-1.73",
  "crm-index-associations-lib": "static-1.6838",
  "stylex-utils": "static-1.156",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "tanstack-virtual": "static-1.41",
  "hubspotter-http-shared-msw-handlers": "static-1.10755",
  "magpie-lib": "static-1.5829",
  "navigation-messaging": "static-1.8318",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23374",
  "copilot-toolkit": "static-1.11992",
  "cms-field-types": "static-1.5203",
  "content-icons-ui": "static-1.2413",
  "integrations-lib": "static-1.17240",
  "calling-global-api": "static-1.65886",
  "calling-internal-common": "static-1.31713",
  "calling-lifecycle-internal": "static-1.67268",
  "calling-lifecycle-messages": "static-1.59561",
  "commerce-products-lib": "static-1.10709",
  "crm-index-visualization-core": "static-1.4645",
  "crm-links": "static-1.6692",
  "customer-data-properties-shared-msw-handlers": "static-1.10084",
  "file-manager-components": "static-1.24675",
  "formula-editor": "static-1.14895",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4480",
  "meetings-icalendar-utils-lib": "static-1.1027",
  "object-builder-ui-client": "static-1.49859",
  "pipeline-validation-client-types": "static-1.4239",
  "property-value-citations": "static-1.3436",
  "smart-data-capture-core": "static-1.285",
  "smart-property-lib": "static-1.8471",
  "tiered-pricing": "static-1.2093",
  "topics-actions-lib": "static-1.565",
  "trial-components-library": "static-1.14244",
  "ui-addon-iframeable": "static-1.9470",
  "zustand": "static-1.86",
  "final-form": "static-1.81",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.81",
  "rich-text-lib": "static-1.20431",
  "tinymce-themes": "static-1.57224",
  "data-token-picker": "static-1.17005",
  "hub-http-contrib": "static-1.3417",
  "interframe": "static-3.5133",
  "tinymce-data": "static-1.41339",
  "tinymce-plugins": "static-1.58368",
  "ui-addon-sales-email": "static-1.5594",
  "framework-data-schema-quick-fetch": "static-1.7191",
  "ui-addon-opt": "static-4.8756",
  "hubspot-apollo-cache": "static-1.725",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.538",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.93",
  "purchase-motions-api": "static-1.6535",
  "onboarding-data-sync-lib": "static-1.2693",
  "growth-onboarding-next-action-components": "static-1.2867",
  "user-context-client": "static-1.4901",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5289",
  "nest": "static-1.627",
  "reactive-lib": "static-1.1112",
  "simple-logging-lib": "static-1.3444",
  "unified-auth-core-lib": "static-1.1370",
  "getting-started-shared-tasks-store": "static-1.18522",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1953",
  "integrations-error-boundary-lib": "static-1.14655",
  "integrations-tracking-lib": "static-1.6002",
  "native-integrations-shared-strings": "static-1.8155",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10762",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1088",
  "calling-error-reporting": "static-1.31720",
  "shared-worker-versioning": "static-1.11432",
  "calling-usage-tracker": "static-1.6927",
  "voice-sms-access-library": "static-1.2255",
  "customer-data-tracking": "static-1.7263",
  "commerce-permissions": "static-1.1168",
  "products-iframe-lib": "static-1.8733",
  "products-ui-components-shared-msw-handlers": "static-1.11139",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10840",
  "sales-views-client-types": "static-1.4648",
  "location-customization-utils-lib": "static-1.10262",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4535",
  "poll-commands": "static-1.3863",
  "video-components-external": "static-1.12293",
  "video-data-lib": "static-1.35951",
  "bark-lib": "static-1.16921",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6280",
  "react-codemirror": "static-1.11033",
  "data-agent-kit": "static-1.765",
  "feedback-loader": "static-1.29931",
  "fsm": "static-1.4145",
  "policy-lib": "static-1.7199",
  "react-colorpicker": "static-2.10604",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10903",
  "embedded-academy-lib": "static-1.15744",
  "hubs-service-types": "static-1.1653",
  "nudge-client-utils": "static-1.3273",
  "salesImages": "static-1.653",
  "FileManagerLib": "static-1.40315",
  "NamespacedHubStyle": "static-2.9315",
  "FileManagerCore": "static-1.40174",
  "content-assistance-lib": "static-1.8309",
  "layout-dnd-components": "static-1.13092",
  "layout-dnd-utils": "static-1.12067",
  "ui-addon-emoji-picker": "static-1.10260",
  "ui-brand-identity-lib": "static-1.16745",
  "InboxConnectUtils": "static-4.15701",
  "meetings-connect-utils-lib": "static-1.8006",
  "breeze-engine-chat-components": "static-1.931",
  "breeze-engine-core": "static-1.1231",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "universal-page-editor-lib": "static-1.3402",
  "adobe-sign-auth-lib": "static-1.619",
  "ads-unified-auth-lib": "static-1.1666",
  "custom-vendor-connection-lib": "static-1.138",
  "google-sheets-integration-lib": "static-1.1181",
  "microsoft-drive-auth-lib": "static-1.336",
  "surveymonkey-integration-lib": "static-1.685",
  "slack-ui-library": "static-1.10789",
  "calling-orchestration-schema": "static-1.37032",
  "crm-record-cards-service-types": "static-1.3825",
  "content-media-composition-data-lib": "static-1.13424",
  "content-media-compositions": "static-2.17431",
  "media-bridge-lib": "static-1.19523",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16513",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4898",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15204",
  "nudge-custom-function-registry": "static-1.3030",
  "nudge-renderer-utils": "static-1.3349",
  "whisper-core-api": "static-1.7484",
  "audio-components": "static-1.6458",
  "FileManagerImages": "static-1.37826",
  "video-components": "static-1.14295",
  "breeze-artifacts-sdk": "static-1.606",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4908",
  "video-embed": "static-1.36785",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29457",
  "ContentData": "static-1.69372",
  "layout-data-lib": "static-1.10392",
  "academy-service-client": "static-1.4084",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4786",
  "trellis-ecosystem": "static-1.7736",
  "ui-addon-react-router-dom": "static-1.9921",
  "wootric-nps": "static-1.7252",
  "social-insights-client-types": "static-1.22783",
  "outpost": "static-1.4529",
  "growth-onboarding-feedback-components": "static-1.6977",
  "advanced-menus-core": "static-1.15688",
  "advanced-menus-lib": "static-1.12509",
  "ExportDialog": "static-6.10769",
  "ui-memberships-settings-lib": "static-1.34991",
  "marketplace-ui-apps-core": "static-1.19436",
  "marketplace-ui-common": "static-1.20904",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15687",
  "simple-menus-lib": "static-1.17204",
  "settings-ui-lib": "static-1.12917",
  "developer-experience-shared-components": "static-1.10928",
  "immutable-less": "static-1.5042",
  "marketplace-ui-client-types": "static-1.18311",
  "ui-addon-integrations-directory-panel": "static-2.8384",
  "ui-extensibility-client-types": "static-1.4308",
  "ai-settings-ui-library": "static-1.8457",
  "nav-meta": "static-1.30628",
  "ui-product-approvals-common": "static-1.1337",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "simple-data-table": "static-1.3665"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35390",
  "atom": "/atom/static-1.5471",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2874",
  "client-types": "/client-types/static-1.504",
  "cssUtils": "/cssUtils/static-1.1012",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41148",
  "customer-data-objects": "/customer-data-objects/static-1.8083",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8458",
  "documents-lib": "/documents-lib/static-1.35395",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.377",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86708",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5104",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2586",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5981",
  "hs-test-utils": "/hs-test-utils/static-1.8428",
  "hub-http": "/hub-http/static-1.6602",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12190",
  "HubStyleTokens": "/HubStyleTokens/static-2.11883",
  "I18n": "/I18n/static-7.1690",
  "icons": "/icons/static-2.698",
  "jasmine-immutable": "/jasmine-immutable/static-1.3371",
  "jasmine-runner": "/jasmine-runner/static-1.6839",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7542",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3280",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5773",
  "quartz": "/quartz/static-1.7560",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17120",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5611",
  "react-virtualized": "/react-virtualized/static-2.110",
  "reference-resolvers": "/reference-resolvers/static-1.8573",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8494",
  "reporting-data": "/reporting-data/static-1.69085",
  "reporting-reports": "/reporting-reports/static-1.68761",
  "reporting-snowflake": "/reporting-snowflake/static-1.57701",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11018",
  "reporting-visualizations": "/reporting-visualizations/static-1.61159",
  "reselect": "/reselect/static-3.15",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9335",
  "sanitize": "/sanitize/static-1.4863",
  "sanitize-text": "/sanitize-text/static-1.8549",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2121",
  "signup-constants": "/signup-constants/static-1.19768",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8449",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "superstore": "/superstore/static-1.5151",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5138",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11334",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11493",
  "ui-images": "/ui-images/static-2.1268",
  "UIComponents": "/UIComponents/static-3.8829",
  "usage-tracker": "/usage-tracker/static-1.7703",
  "usage-tracker-container": "/usage-tracker-container/static-1.7693",
  "usage-tracker-core": "/usage-tracker-core/static-1.7553",
  "viral-links-lib": "/viral-links-lib/static-1.7466",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10038",
  "foundations-components": "/foundations-components/static-1.8622",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1338",
  "quartz-core": "/quartz-core/static-1.6779",
  "quick-fetch": "/quick-fetch/static-1.4180",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.5058",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11540",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18485",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3837",
  "quartz-webpack": "/quartz-webpack/static-1.3784",
  "foundations-assets": "/foundations-assets/static-1.5280",
  "foundations-theming": "/foundations-theming/static-1.4870",
  "hub-http-janus": "/hub-http-janus/static-1.895",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10757",
  "hubspotter-http": "/hubspotter-http/static-1.4915",
  "sassPrefix": "/sassPrefix/static-1.280",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43929",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23583",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13421",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13560",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10223",
  "events-data-lib": "/events-data-lib/static-1.639",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4277",
  "hs-resources": "/hs-resources/static-1.584",
  "immer": "/immer/static-1.104",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3729",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4099",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1395",
  "onboarding-scopes": "/onboarding-scopes/static-1.6844",
  "onboarding-tours": "/onboarding-tours/static-1.17262",
  "pulse": "/pulse/static-1.1027",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14614",
  "segments-client-types": "/segments-client-types/static-1.11861",
  "stylex": "/stylex/static-1.45",
  "trellis-assets": "/trellis-assets/static-1.2877",
  "trellis-components": "/trellis-components/static-1.2896",
  "trellis-theming": "/trellis-theming/static-1.1368",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "quartz-auth": "/quartz-auth/static-1.1235",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9485",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5389",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9879",
  "ContentUtils": "/ContentUtils/static-1.69297",
  "customer-data-properties": "/customer-data-properties/static-1.52822",
  "forms-ai-lib": "/forms-ai-lib/static-1.4870",
  "forms-utils-lib": "/forms-utils-lib/static-1.13208",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6105",
  "react-dnd-compat": "/react-dnd-compat/static-1.5005",
  "react-tinymce": "/react-tinymce/static-1.56128",
  "tinymce-config": "/tinymce-config/static-2.55254",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10648",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3855",
  "HeadJS": "/HeadJS/static-2.810",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3539",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.15",
  "testing-library": "/testing-library/static-1.162",
  "hs-locale-management": "/hs-locale-management/static-1.350",
  "ui-fonts": "/ui-fonts/static-1.1145",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4701",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1225",
  "web-vitals": "/web-vitals/static-1.18",
  "batch-promise": "/batch-promise/static-1.1937",
  "external-options-client-types": "/external-options-client-types/static-1.4397",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7286",
  "quartz-i18n": "/quartz-i18n/static-1.1235",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8312",
  "graphql": "/graphql/static-1.92",
  "persist-promise": "/persist-promise/static-1.4094",
  "reporting-client-types": "/reporting-client-types/static-1.2764",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "growth-payments-core": "/growth-payments-core/static-1.26343",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5266",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1647",
  "quartz-routing": "/quartz-routing/static-1.990",
  "hs-story-utils": "/hs-story-utils/static-1.9816",
  "react-flip-move": "/react-flip-move/static-1.81",
  "nested-table": "/nested-table/static-1.627",
  "seat-types-lib": "/seat-types-lib/static-1.888",
  "timezone-utils": "/timezone-utils/static-2.5622",
  "react-create-root-preference": "/react-create-root-preference/static-1.87",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4891",
  "floating-ui": "/floating-ui/static-1.66",
  "react-aria": "/react-aria/static-1.75",
  "tanstack-table": "/tanstack-table/static-1.64",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.176",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.591",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.551",
  "quartz-test": "/quartz-test/static-1.1235",
  "quartz-tracking": "/quartz-tracking/static-1.939",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.468",
  "chirp-fetch": "/chirp-fetch/static-1.2292",
  "merchandise-lib": "/merchandise-lib/static-1.282",
  "purchase-motions-components": "/purchase-motions-components/static-1.6532",
  "ts-schema": "/ts-schema/static-1.4350",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3353",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1855",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5014",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4072",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4402",
  "event-emitter": "/event-emitter/static-1.1350",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.405",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3966",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19404",
  "growth-data-modal": "/growth-data-modal/static-1.6010",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3455",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2839",
  "navigation-components": "/navigation-components/static-1.18991",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5477",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1329",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10663",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8044",
  "ui-universal-auth": "/ui-universal-auth/static-1.9574",
  "user-context": "/user-context/static-1.5473",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.530",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6838",
  "stylex-utils": "/stylex-utils/static-1.156",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10755",
  "magpie-lib": "/magpie-lib/static-1.5829",
  "navigation-messaging": "/navigation-messaging/static-1.8318",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23374",
  "copilot-toolkit": "/copilot-toolkit/static-1.11992",
  "cms-field-types": "/cms-field-types/static-1.5203",
  "content-icons-ui": "/content-icons-ui/static-1.2413",
  "integrations-lib": "/integrations-lib/static-1.17240",
  "calling-global-api": "/calling-global-api/static-1.65886",
  "calling-internal-common": "/calling-internal-common/static-1.31713",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67268",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59561",
  "commerce-products-lib": "/commerce-products-lib/static-1.10709",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4645",
  "crm-links": "/crm-links/static-1.6692",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10084",
  "file-manager-components": "/file-manager-components/static-1.24675",
  "formula-editor": "/formula-editor/static-1.14895",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4480",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1027",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49859",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4239",
  "property-value-citations": "/property-value-citations/static-1.3436",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.285",
  "smart-property-lib": "/smart-property-lib/static-1.8471",
  "tiered-pricing": "/tiered-pricing/static-1.2093",
  "topics-actions-lib": "/topics-actions-lib/static-1.565",
  "trial-components-library": "/trial-components-library/static-1.14244",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9470",
  "zustand": "/zustand/static-1.86",
  "final-form": "/final-form/static-1.81",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "rich-text-lib": "/rich-text-lib/static-1.20431",
  "tinymce-themes": "/tinymce-themes/static-1.57224",
  "data-token-picker": "/data-token-picker/static-1.17005",
  "hub-http-contrib": "/hub-http-contrib/static-1.3417",
  "interframe": "/interframe/static-3.5133",
  "tinymce-data": "/tinymce-data/static-1.41339",
  "tinymce-plugins": "/tinymce-plugins/static-1.58368",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5594",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7191",
  "ui-addon-opt": "/ui-addon-opt/static-4.8756",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.725",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.538",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.93",
  "purchase-motions-api": "/purchase-motions-api/static-1.6535",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2693",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2867",
  "user-context-client": "/user-context-client/static-1.4901",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5289",
  "nest": "/nest/static-1.627",
  "reactive-lib": "/reactive-lib/static-1.1112",
  "simple-logging-lib": "/simple-logging-lib/static-1.3444",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1370",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18522",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1953",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14655",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6002",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8155",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10762",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1088",
  "calling-error-reporting": "/calling-error-reporting/static-1.31720",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11432",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6927",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2255",
  "customer-data-tracking": "/customer-data-tracking/static-1.7263",
  "commerce-permissions": "/commerce-permissions/static-1.1168",
  "products-iframe-lib": "/products-iframe-lib/static-1.8733",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11139",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10840",
  "sales-views-client-types": "/sales-views-client-types/static-1.4648",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10262",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4535",
  "poll-commands": "/poll-commands/static-1.3863",
  "video-components-external": "/video-components-external/static-1.12293",
  "video-data-lib": "/video-data-lib/static-1.35951",
  "bark-lib": "/bark-lib/static-1.16921",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6280",
  "react-codemirror": "/react-codemirror/static-1.11033",
  "data-agent-kit": "/data-agent-kit/static-1.765",
  "feedback-loader": "/feedback-loader/static-1.29931",
  "fsm": "/fsm/static-1.4145",
  "policy-lib": "/policy-lib/static-1.7199",
  "react-colorpicker": "/react-colorpicker/static-2.10604",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10903",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15744",
  "hubs-service-types": "/hubs-service-types/static-1.1653",
  "nudge-client-utils": "/nudge-client-utils/static-1.3273",
  "salesImages": "/salesImages/static-1.653",
  "FileManagerLib": "/FileManagerLib/static-1.40315",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9315",
  "FileManagerCore": "/FileManagerCore/static-1.40174",
  "content-assistance-lib": "/content-assistance-lib/static-1.8309",
  "layout-dnd-components": "/layout-dnd-components/static-1.13092",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12067",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10260",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16745",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15701",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8006",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.931",
  "breeze-engine-core": "/breeze-engine-core/static-1.1231",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3402",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.619",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1666",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.138",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1181",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.336",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.685",
  "slack-ui-library": "/slack-ui-library/static-1.10789",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37032",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3825",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13424",
  "content-media-compositions": "/content-media-compositions/static-2.17431",
  "media-bridge-lib": "/media-bridge-lib/static-1.19523",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16513",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4898",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15204",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3030",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3349",
  "whisper-core-api": "/whisper-core-api/static-1.7484",
  "audio-components": "/audio-components/static-1.6458",
  "FileManagerImages": "/FileManagerImages/static-1.37826",
  "video-components": "/video-components/static-1.14295",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.606",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4908",
  "video-embed": "/video-embed/static-1.36785",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29457",
  "ContentData": "/ContentData/static-1.69372",
  "layout-data-lib": "/layout-data-lib/static-1.10392",
  "academy-service-client": "/academy-service-client/static-1.4084",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4786",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7736",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9921",
  "wootric-nps": "/wootric-nps/static-1.7252",
  "social-insights-client-types": "/social-insights-client-types/static-1.22783",
  "outpost": "/outpost/static-1.4529",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6977",
  "advanced-menus-core": "/advanced-menus-core/static-1.15688",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12509",
  "ExportDialog": "/ExportDialog/static-6.10769",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34991",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19436",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20904",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15687",
  "simple-menus-lib": "/simple-menus-lib/static-1.17204",
  "settings-ui-lib": "/settings-ui-lib/static-1.12917",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10928",
  "immutable-less": "/immutable-less/static-1.5042",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18311",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8384",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4308",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8457",
  "nav-meta": "/nav-meta/static-1.30628",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1337",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "simple-data-table": "/simple-data-table/static-1.3665"
}
};
